import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const W = 794; const H = 1123;
const FONT = "'Inter', 'Helvetica Neue', Arial, sans-serif";

const block = (title, color, body) => `
  <div style="border-left:4px solid ${color};padding:2px 0 2px 12px;margin-bottom:16px;">
    <div style="font-size:14px;font-weight:700;color:#14082b;letter-spacing:0.02em;margin-bottom:5px;">${title}</div>
    <div style="font-size:12.5px;line-height:1.55;color:#2b2540;">${body}</div>
  </div>`;

const SESSION = [
  ['10 min', 'Arrive and settle in the calm waiting space'],
  ['15 min', 'Meet the guide and explore the simulator room'],
  ['20 min', 'Learn the controls, step by step'],
  ['30 min', 'Simulator time in small, unhurried turns'],
  ['15 min', 'Calm debrief, questions and badges'],
];

const html = () => `
<div style="width:${W}px;height:${H}px;background:#fff;font-family:${FONT};box-sizing:border-box;position:relative;overflow:hidden;">
  <div style="background:#0a0416;color:#fff;padding:26px 48px 22px;">
    <div style="display:flex;justify-content:space-between;align-items:center;">
      <img src="/img/n3uro-world-logo-wide.png" crossorigin="anonymous" style="height:46px;" alt="" />
      <div style="font-size:11px;letter-spacing:0.16em;color:#5BE9FF;font-weight:700;">SCHOOL INFO PACK</div>
    </div>
    <div style="font-size:28px;font-weight:800;margin-top:16px;">N3URO Academy</div>
    <div style="font-size:13px;color:#d9d2f0;margin-top:4px;">Neuro-inclusive Flight and Rail learning pathways for schools and organisations</div>
    <div style="height:4px;margin-top:16px;border-radius:4px;background:linear-gradient(90deg,#5BE9FF,#C77DFF,#FF6BD5,#FFB166);"></div>
  </div>
  <div style="padding:22px 48px 0;display:grid;grid-template-columns:1fr 1fr;gap:0 28px;">
    <div>
      ${block('What the Academy is', '#5BE9FF', 'N3URO Academy helps children and young people explore aviation and rail at a pace that suits them. Online lessons are open now, and on-site simulator sessions are open for registered interest.')}
      ${block('Two pathways', '#C77DFF', '<b>Flight Academy:</b> airports, aircraft, flight principles and simulation.<br/><b>Rail Academy:</b> stations, signalling, train systems and simulation.')}
      ${block('Age levels', '#FFB166', '<b>Discover (5–7):</b> first journeys and the sensory side of travel.<br/><b>Explore (8–11):</b> how aircraft and trains work.<br/><b>Advance (12–16):</b> systems, planning and simulation skills.')}
      ${block('On-site simulator sessions', '#FF6BD5', 'Selective 90-minute workshops, with no more than 12–14 children per session and age group. Every session is led by a qualified instructor, with school staff or parents and carers present.')}
    </div>
    <div>
      <div style="border:1px solid #e3dcf5;border-radius:12px;padding:14px 16px;margin-bottom:14px;background:#faf8ff;">
        <div style="font-size:13px;font-weight:700;color:#14082b;margin-bottom:8px;">A sample 90-minute session</div>
        ${SESSION.map(([t, d]) => `<div style="display:flex;gap:10px;font-size:12.5px;line-height:1.5;color:#2b2540;margin-bottom:6px;"><span style="flex:0 0 52px;font-weight:700;color:#7b3fe4;">${t}</span><span>${d}</span></div>`).join('')}
        <div style="font-size:10px;color:#6b6585;margin-top:6px;">Timings flex to suit the group. Breaks are always available.</div>
      </div>
      ${block('Sensory support', '#B8FF5B', 'A quiet waiting space with soft, adjustable lighting. Simulator sound can be turned down, and we always give a warning before louder moments. Ear defenders and headphones are welcome. Children can take a break at any time.')}
      ${block('Simulations, not professional training', '#FFE066', 'Sessions are educational experiences that build curiosity and confidence. They are not professional pilot or train-driver training.')}
    </div>
  </div>
  <div style="margin:6px 48px 18px;display:grid;grid-template-columns:repeat(3,1fr);gap:10px;">
    ${[['flight-1', 'Flight simulator cockpit'], ['flight-wait', 'Calm waiting space'], ['rail-1', 'Train cab simulator']].map(([k, c]) => `
      <figure style="margin:0;">
        <img src="/img/academy-gallery-${k}.webp" crossorigin="anonymous" style="display:block;width:100%;height:140px;object-fit:cover;border-radius:10px;" alt="" />
        <figcaption style="font-size:10px;color:#6b6585;margin-top:4px;">${c}</figcaption>
      </figure>`).join('')}
  </div>
  <div style="margin:0 48px;padding:16px 18px;border-radius:12px;background:#0a0416;color:#fff;">
    <div style="font-size:14px;font-weight:700;color:#B8FF5B;margin-bottom:6px;">How to enquire</div>
    <div style="font-size:12.5px;line-height:1.6;color:#e8e2fa;">
      Send an institutional enquiry at <b>n3uro.world/academy/institutions</b> or email <b>hello@n3uro.world</b>.
      Tell us about your setting, the pathway and the age groups, and we&rsquo;ll be in touch as soon as group dates open.
      An enquiry is not a booking, and no payment is taken.
    </div>
  </div>
  <div style="position:absolute;left:48px;right:48px;bottom:22px;display:flex;justify-content:space-between;font-size:9.5px;color:#7a7494;border-top:1px solid #ece7f7;padding-top:8px;">
    <span>N3URO WORLD® · Neuro-Inclusive Family Infrastructure</span>
    <span>n3uro.world · hello@n3uro.world</span>
  </div>
</div>`;

export const downloadInfoPack = async () => {
  const host = document.createElement('div');
  host.style.cssText = 'position:fixed;left:-10000px;top:0;z-index:-1;';
  host.innerHTML = html();
  document.body.appendChild(host);
  try {
    await Promise.all([...host.querySelectorAll('img')].map((img) => (img.complete ? null : new Promise((r) => { img.onload = r; img.onerror = r; }))));
    const canvas = await html2canvas(host.firstElementChild, { scale: 2, useCORS: true, backgroundColor: '#ffffff', logging: false });
    const pdf = new jsPDF({ unit: 'pt', format: 'a4', compress: true });
    pdf.addImage(canvas.toDataURL('image/jpeg', 0.92), 'JPEG', 0, 0, pdf.internal.pageSize.getWidth(), pdf.internal.pageSize.getHeight());
    pdf.setProperties({ title: 'N3URO Academy · School Info Pack', author: 'N3URO WORLD®', creator: 'N3URO WORLD® · n3uro.world' });
    pdf.save('N3URO-Academy-School-Info-Pack.pdf');
  } finally {
    host.remove();
  }
};
